import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

type UpdateLeadLinkProps = {
    id: string
    dealerUserId?: string
    salesPersonId?: string
    dealershipId?: number
}

export async function updateLeadLink({
    id,
    dealerUserId,
    salesPersonId,
    dealershipId,
}: UpdateLeadLinkProps) {
    const requestBody = {
        salesperson_id: salesPersonId,
        dealer_user_id: dealerUserId,
        dealership_id: dealershipId,
    }

    try {
        await axios.post(
            `${config.API_BASE_URL}/api/v3/client-application/${id}/update_dealer_assigned_application/`,
            requestBody,
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return true
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to update dealer assigned application: ${axiosError.message}`,
            axiosError,
        )

        throw axiosError
    }
}

export async function unassignLeadLink({ id }: UpdateLeadLinkProps) {
    try {
        await axios.post(
            `${config.API_BASE_URL}/api/v3/client-application/${id}/unassign_dealer_assigned_application/`,
            undefined,
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return true
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to update dealer assigned application: ${axiosError.message}`,
            axiosError,
        )

        throw axiosError
    }
}
